import { render } from "./TeamAssignment.vue?vue&type=template&id=2110e3a0&scoped=true"
import script from "./TeamAssignment.vue?vue&type=script&lang=js"
export * from "./TeamAssignment.vue?vue&type=script&lang=js"

import "./TeamAssignment.vue?vue&type=style&index=0&id=2110e3a0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2110e3a0"]])

export default __exports__